import { SwipeableCoreProps } from "./types"
import React, { useRef } from "react"
import { ReanimatedSwipeable as Swipeable } from "~/ui/gesture-handler"
import SwipeableActions from "./swipeable-actions"

export const SwipeableCore: React.FC<SwipeableCoreProps> = ({
  item,
  actions,
  children,
  activeOffsetX = [-35, 35],
  failOffsetY = [-22, 22],
  ...rest
}) => {
 const ref = useRef<React.ElementRef<typeof Swipeable>>(null)
  const closeSwipe = () => {
    if (ref.current) {
      ref?.current.close()
    }
  }
  return (
    <Swipeable
      {...rest}
      ref={ref}
      activeOffsetX={activeOffsetX}
      failOffsetY={failOffsetY}
      renderRightActions={() => (
        <SwipeableActions closeSwipe={closeSwipe} item={item} actions={actions} />
      )}
    >
      {children}
    </Swipeable>
  )
}
